export const pagePaths = {
	pagePlugins: ["plugins"],
	pageStandard: [""],
	pageProduct: ["features"],
	pageGuide: ["guides", "tutorials"],
	pageVideoSeries: ["series"],
	pageReleaseNotes: ["updates"],
};
